module.exports = __webpack_public_path__ + "static/media/gu.a269eb55.svg";